import { render } from "./cswitch.vue?vue&type=template&id=35dd652f&scoped=true"
import script from "./cswitch.vue?vue&type=script&lang=js"
export * from "./cswitch.vue?vue&type=script&lang=js"

import "./cswitch.vue?vue&type=style&index=0&id=35dd652f&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dd652f"]])

export default __exports__